import CommonSubtitle from "@/components/common/CommonSubtitle";
import CommonTitle from "@/components/common/CommonTitle";
import summarizer from "@/assets/images/icons/navbar/AiTools/summarizer.svg";
import translator from "@/assets/images/icons/navbar/AiTools/translator.svg";
import paraphraser from "@/assets/images/icons/navbar/AiTools/paraphraser.svg";
import grammarChecker from "@/assets/images/icons/navbar/AiTools/grammar-checker.svg";
import ToolTabs from "./ToolTabs";
import bgToolTopImage from "@/assets/images/pricing/hero-background.svg";

type TProps = {
  title: string;
  subtitle: string;
};

const ToolTopArea = ({
  children,
  pageInfo,
  subSectionPageInfo,
}: {
  children: React.ReactNode;
  pageInfo: TProps;
  subSectionPageInfo?: TProps;
}) => {

  const links = [
    {
      href: "/ai-tools/grammar-checker",
      label: "Grammar Checker",
      icon: grammarChecker,
    },
    { href: "/ai-tools/summarizer", label: "Summarizer", icon: summarizer },
    { href: "/ai-tools/translator", label: "Translator", icon: translator },
    { href: "/ai-tools/paraphraser", label: "Paraphraser", icon: paraphraser },
  ];
  return (
    <>
      <section className="relative z-10 block overflow-hidden pt-[72px] sm:pt-20 md:pt-24 lg:hidden lg:pt-28 xl:pt-[90px] 2xl:pt-[110px]" style={{ backgroundImage: `url(${bgToolTopImage.src})`, backgroundColor: "#ffffff", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center" }}>
        <div className="container w-full px-4 sm:px-6 md:w-11/12 lg:w-3/4">
          <ToolTabs links={links} layout="row" />
          <div className="flex flex-col items-center gap-6 text-left sm:gap-8 lg:gap-10 xl:gap-12">
            <div className="space-y-2 sm:space-y-3 md:space-y-4 lg:mb-0 xlg:max-w-4xl xl:mb-0 3xl:my-[10px]">
              <CommonTitle
                as="h1"
                fontWeightClass="font-semibold"
                fontSizeClass="text-[32px] font-semibold xl:text-[40px]"
                color="#202020"
              >
                {pageInfo.title}
              </CommonTitle>
              <CommonSubtitle
                color="#717171"
                fontSizeWeight="text-[14px] lg:text-[16px] font-normal"
              >
                {pageInfo.subtitle}
              </CommonSubtitle>
            </div>
          </div>
        </div>
        <div className="container mb-8 px-4 sm:mb-12 sm:px-6 md:mb-16 lg:mb-20">
          {children}
        </div>
        {subSectionPageInfo && (
          <div className="container w-full px-4 sm:px-6 md:w-11/12 lg:w-4/6 xl:w-2/4">
            <div className="flex flex-col items-center gap-6 text-center sm:gap-8 lg:gap-10 xl:gap-12">
              <div className="space-y-3 sm:space-y-4 md:space-y-5 lg:mb-20 lg:mt-0 xl:mb-20 xl:mt-0 xl:space-y-10 3xl:mb-[100px] 3xl:mt-[10px]">
                <CommonTitle
                  as="h2"
                  color="#202020"
                  fontSizeClass="text-[24px] lg:text-[32px]"
                >
                  {subSectionPageInfo.title}
                </CommonTitle>
                <CommonSubtitle
                  color="#717171"
                  fontSizeWeight="font-normal text-[14px] xl:text-[16px]"
                >
                  {subSectionPageInfo.subtitle}
                </CommonSubtitle>
              </div>
            </div>
          </div>
        )}
      </section>
      <section className="relative z-10 hidden overflow-hidden pt-24 sm:pt-20 md:pt-24 lg:block lg:pt-28 xl:pt-[90px] 2xl:pt-[110px]" style={{ backgroundImage: `url(${bgToolTopImage.src})`, backgroundColor: "#ffffff", backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center" }}>
        <div className="container flex gap-4">
          <ToolTabs links={links} layout="column" />
          <div className="flex w-full flex-col items-start justify-center">
            <div className="px-4 sm:px-6">
              <div className="flex flex-col gap-6 sm:gap-8 lg:gap-10 xl:gap-12">
                <div className="space-y-1 lg:mb-0 xl:mb-0 3xl:my-[10px]">
                  <CommonTitle
                    as="h2"
                    fontWeightClass="font-semibold"
                    fontSizeClass="text-[32px] xl:text-[40px]"
                    color="#202020"
                  >
                    {pageInfo.title}
                  </CommonTitle>
                  <CommonSubtitle
                  >
                    {pageInfo.subtitle}
                  </CommonSubtitle>
                </div>
              </div>
            </div>
            {/* Middle Content */}
            <div className="mb-8 w-full px-4 sm:px-6">{children}</div>
          </div>
        </div>
        {subSectionPageInfo && (
          <div className="container w-full px-4 sm:px-6 md:w-11/12 lg:w-4/6 xl:w-2/4">
            <div className="flex flex-col items-center gap-6 text-center sm:gap-8 lg:gap-10 xl:gap-12">
              <div className="space-y-3 sm:space-y-4 md:space-y-5 lg:mb-20 lg:mt-0 xl:mb-20 xl:mt-0 xl:space-y-10 3xl:mb-[100px] 3xl:mt-[10px]">
                <CommonTitle
                  as="h2"
                  color="#202020"
                  fontSizeClass="text-[24px] lg:text-[32px]"
                >
                  {subSectionPageInfo.title}
                </CommonTitle>
                <CommonSubtitle
                  color="#717171"
                  fontSizeWeight="font-normal text-[14px] xl:text-[16px]"
                >
                  {subSectionPageInfo.subtitle}
                </CommonSubtitle>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default ToolTopArea;
